export const qsArrayTransform = (property) => {
  const urlParams = new URLSearchParams(window.location.search);
  const newUrlParams = new URLSearchParams();

  if (urlParams.has(property)) {
    const arrayStr = urlParams.get('filter').replaceAll(`'`, `"`);
    const array = JSON.parse(arrayStr);
    array.forEach((value) => newUrlParams.append('filter', value));
  }

  return newUrlParams.toString();
};
